import React from 'react';

export default function GrantAIdeGradientBorder({
  children,
  width = '100%',
  height = 'auto',
  className = '',
  contentClassName = '',
}) {
  return (
    <div
      className={className}
      style={{
        background: 'linear-gradient(to top right, #D923B7, #8353E6, #488CF2, #60E5BA)',
        padding: '1px',
        borderRadius: '8px',
        // Allow Tailwind height classes (for example, h-[40px]) to control
        // the component when no explicit height prop has been supplied.
        width,
        ...(height !== 'auto' ? { height } : {}),
      }}
    >
      <div
        className={contentClassName}
        style={{
          backgroundColor: '#110026',
          width: '100%',
          height: '100%',
          borderRadius: '7px',
          boxSizing: 'border-box',
        }}
      >
        {children}
      </div>
    </div>
  );
}